import React, { Fragment } from 'react';
import { Box, Text } from '@nerdwallet/currency';
import Close from '@nerdwallet/react-icon/material/Close';
import analyticsLib from '@nerdwallet/analytics';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { ElementImpression, ElementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import styles from '../comparison-grid.module.less';
import { EVENT_TYPES, ENTITY_NAME, SECTION_NAME, ACTION, INTERACTION_TYPE } from '../../lib/analytics-constants';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export var SkittlePopoverText = function SkittlePopoverText(_ref) {
  var updateShowSkittlePopover = _ref.updateShowSkittlePopover,
      skittleTitle = _ref.skittleTitle,
      skittleContent = _ref.skittleContent;

  var internalPopoverCloseClick = function internalPopoverCloseClick(impressionId) {
    analyticsLib.track(EVENT_TYPES.ELEMENT_INTERACTED, {
      action: ACTION.CLOSE,
      entity_name: ENTITY_NAME.COMPARISON_GRID_SKITTLE_CONTENT,
      interaction_type: INTERACTION_TYPE.PRESS,
      impression_id: impressionId
    });
    updateShowSkittlePopover(false);
  };

  return /*#__PURE__*/React.createElement(ElementImpression, {
    id: ENTITY_NAME.COMPARISON_GRID_SKITTLE_CONTENT,
    elementName: ENTITY_NAME.COMPARISON_GRID_SKITTLE_CONTENT,
    sectionCategory: SECTION_NAME.COMPARISON_GRID_POPOVER
  }, /*#__PURE__*/React.createElement(Impression, {
    className: styles.skittlePopover,
    eventType: EVENT_TYPES.ELEMENT_IMPRESSION,
    entityName: ENTITY_NAME.COMPARISON_GRID_SKITTLE_CONTENT,
    payload: {
      section_name: SECTION_NAME.COMPARISON_GRID_POPOVER
    }
  }, /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (impressionContext) {
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ElementInteraction, {
      elementCategory: "close",
      elementName: ENTITY_NAME.COMPARISON_GRID_SKITTLE_CONTENT,
      id: "".concat(ENTITY_NAME.COMPARISON_GRID_SKITTLE_CONTENT, "_close"),
      type: "CLICK"
    }, /*#__PURE__*/React.createElement("span", {
      onClick: function onClick() {
        return internalPopoverCloseClick(impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId);
      }
    }, /*#__PURE__*/React.createElement(Close, {
      className: styles.skittlePopoverClose
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles.skittlePopoverText
    }, /*#__PURE__*/React.createElement(Box, {
      className: styles.skittlePopoverTitle
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true
    }, skittleTitle)), /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, skittleContent)));
  })));
};
SkittlePopoverText.defaultProps = {
  skittleTitle: 'Start comparing cards',
  skittleContent: "The cards you add to compare will appear here. Easily compare\n\nkey features of cards you select or ones we recommend."
};